<template>
  <div>
    <h2>Profil Saya</h2>
    <div v-if="loading">Memuat profil...</div>
    <div v-if="error">{{ error }}</div>
    <div v-if="user">
      <p><strong>Nama Lengkap:</strong> {{ user.full_name }}</p>
      <p><strong>Email:</strong> {{ user.email }}</p>
      <p><strong>Peran:</strong> {{ user.role }}</p>
    </div>
  </div>
</template>
<script setup>
import { ref, onMounted } from 'vue';
import api from '@/services/api';

const user = ref(null);
const loading = ref(true);
const error = ref(null);

onMounted(async () => {
  try {
    const response = await api.getUserProfile();
    user.value = response.data;
  } catch (err) {
    error.value = "Gagal memuat profil.";
  } finally {
    loading.value = false;
  }
});
</script>